import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section"];

  connect() {
    this.sectionTargets.forEach ((section) => {
      const {
        header,
        contents,
        icon,
        isCollapsible,
        isCollapsed,
        isLastSection
      } = this.getSectionInfo(section);

      if (isLastSection) {
        this.makeBorderOfLastSectionRound(header, contents, isCollapsed);         
      }      

      if (!isCollapsible) return;

      icon.classList.toggle("rotate-180", !isCollapsed);

      header.addEventListener("click", () => {
        this.toggleSection(section);
      })
    })
  }

  toggleSection(section) {
    const {
      header,
      contents,
      icon,
      isCollapsed,
      isLastSection
    } = this.getSectionInfo(section);

    contents.classList.toggle("hidden", !isCollapsed);
    icon.classList.toggle("rotate-180", isCollapsed);

    if (isLastSection) {
      this.makeBorderOfLastSectionRound(header, contents, !isCollapsed);         
    }    
  }

  makeBorderOfLastSectionRound(header, contents, isCollapsed) {
    if (header) {
      header.classList.toggle("rounded-b", isCollapsed);
    }

    if(contents) {
      contents.classList.toggle("rounded-b", !isCollapsed);
    } 
  }

  getSectionInfo(section) {
    const header = section.querySelector("[data-accordion-header]");
    const contents = section.querySelector("[data-accordion-contents]");
    const icon = section.querySelector("[data-accordion-icon]");

    return {
      header,
      contents,
      icon,
      isCollapsible: !!section.dataset.accordionCollapsible,
      isCollapsed: contents.classList.contains("hidden"),
      isLastSection: (section == this.sectionTargets[this.sectionTargets.length - 1])
    }
  }
}